export const findStoreById = async (
    StoresService: woosmap.map.StoresService,
    storeId: string,
    locale: string,
) => {
    const findStoreByIdQuery = [
        `user.locale:="${locale}"`,
        `user.storeId:="${storeId}"`,
    ].join(" AND ");

    const storeSearchResponse = await StoresService.search({
        query: findStoreByIdQuery,
        storesByPage: 1,
    });

    return storeSearchResponse?.features.find(
        store => store.properties.user_properties.storeId === storeId,
    );
};
